module.exports = __webpack_public_path__ + "6c4a0dbc/img/trash-icon.ff8201c7.svg";